import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  ACCOMMODATION,
  ACCOMMODATION_CHANGE_STATUS,
  ACCOMMODATION_CREATE,
  ACCOMMODATION_DELETE,
  ACCOMMODATION_LIST,
  ACCOMMODATION_STUDENT_INFO,
  GLOBAL_STATE,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const ACCOMMODATIONS = GLOBAL_STATE

export const { reducer: accommodationReducer } = createSlice({
  name: ACCOMMODATIONS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.accommodation.pending, state => {
        state[ACCOMMODATION].loading = true
      })
      .addCase(actionCreators.accommodation.rejected, (state, action) => {
        state[ACCOMMODATION].loading = false
        state[ACCOMMODATION].error = action.payload as AxiosError
      })
      .addCase(actionCreators.accommodation.fulfilled, (state, action) => {
        state[ACCOMMODATION].loading = false
        state[ACCOMMODATION].error = null
        state[ACCOMMODATION].data = action.payload
      })

    builder
      .addCase(actionCreators.accommodationCreate.pending, state => {
        state[ACCOMMODATION_CREATE].loading = true
      })
      .addCase(actionCreators.accommodationCreate.rejected, (state, action) => {
        state[ACCOMMODATION_CREATE].loading = false
        state[ACCOMMODATION_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.accommodationCreate.fulfilled, (state, action) => {
        state[ACCOMMODATION_CREATE].loading = false
        state[ACCOMMODATION_CREATE].error = null
        state[ACCOMMODATION_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.accommodationDelete.pending, state => {
        state[ACCOMMODATION_DELETE].loading = true
      })
      .addCase(actionCreators.accommodationDelete.rejected, (state, action) => {
        state[ACCOMMODATION_DELETE].loading = false
        state[ACCOMMODATION_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.accommodationDelete.fulfilled, (state, action) => {
        state[ACCOMMODATION_DELETE].loading = false
        state[ACCOMMODATION_DELETE].error = null
        state[ACCOMMODATION_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.accommodationList.pending, state => {
        state[ACCOMMODATION_LIST].loading = true
      })
      .addCase(actionCreators.accommodationList.rejected, (state, action) => {
        state[ACCOMMODATION_LIST].loading = false
        state[ACCOMMODATION_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.accommodationList.fulfilled, (state, action) => {
        state[ACCOMMODATION_LIST].loading = false
        state[ACCOMMODATION_LIST].error = null
        state[ACCOMMODATION_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.accommodationStudentInfo.pending, state => {
        state[ACCOMMODATION_STUDENT_INFO].loading = true
      })
      .addCase(actionCreators.accommodationStudentInfo.rejected, (state, action) => {
        state[ACCOMMODATION_STUDENT_INFO].loading = false
        state[ACCOMMODATION_STUDENT_INFO].error = action.payload as AxiosError
      })
      .addCase(actionCreators.accommodationStudentInfo.fulfilled, (state, action) => {
        state[ACCOMMODATION_STUDENT_INFO].loading = false
        state[ACCOMMODATION_STUDENT_INFO].error = null
        state[ACCOMMODATION_STUDENT_INFO].data = action.payload
      })

    builder
      .addCase(actionCreators.accommodationChangeStatus.pending, state => {
        state[ACCOMMODATION_CHANGE_STATUS].loading = true
      })
      .addCase(actionCreators.accommodationChangeStatus.rejected, (state, action) => {
        state[ACCOMMODATION_CHANGE_STATUS].loading = false
        state[ACCOMMODATION_CHANGE_STATUS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.accommodationChangeStatus.fulfilled, (state, action) => {
        state[ACCOMMODATION_CHANGE_STATUS].loading = false
        state[ACCOMMODATION_CHANGE_STATUS].error = null
        state[ACCOMMODATION_CHANGE_STATUS].data = action.payload
      })

    builder.addCase(actionCreators.accommodationClear, state => {
      state[ACCOMMODATION] = defaultState()
    })

    builder.addCase(actionCreators.accommodationListClear, state => {
      state[ACCOMMODATION_LIST] = defaultState()
    })

    builder.addCase(actionCreators.accommodationStudentInfoClear, state => {
      state[ACCOMMODATION_STUDENT_INFO] = defaultState()
    })
  },
})
